import { Button } from 'antd'
import { FC, useEffect, useMemo, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useLocation, useNavigate } from 'react-router-dom'
import {
	RNRegister,
	RNSuccess,
	RNWelcome
} from '../helpers/routeNames'
import { userRequestStore } from '../store/userRequest'
import { UserRequest } from '../helpers/types/userRequest'
import { authStore } from '../store/auth'
import { useTelegram } from '../store/telegram'

const RegisterRequestAsk: FC = () => {
	const location = useLocation()

	const { t } = useTranslation()
	const { findPending, permitRegistration } = userRequestStore()
	const { isLoggedIn, user } = authStore()
	const navigate = useNavigate()
	const { tgUser } = useTelegram()

	const query = useMemo(
		() => new URLSearchParams(location.search),
		[location.search]
	)

	const [userRequest, setUserRequest] = useState<UserRequest>()

	const permitRegister = async (
		decision: 'ALLOWED' | 'REJECTED'
	) => {
		await permitRegistration(decision, userRequest?.telegramId!)
		navigate(RNSuccess + RNRegister + '?result=' + decision)
		return
	}

	useEffect(() => {
		if (user?.role) {
			if (
				!tgUser?.id ||
				!query.has('id') ||
				!['EXECUTIVE', 'ADMIN'].includes(user!.role)
			) {
				navigate(RNWelcome)
				return
			}
		}
		const fetchData = async () => {
			if (!isLoggedIn) return
			try {
				const userRequestData = await findPending(
					+query.get('id')!
				)
				setUserRequest(userRequestData)
			} catch (err) {
				navigate(RNWelcome)
				return
			}
		}

		fetchData()
	}, [findPending, navigate, query, isLoggedIn, tgUser?.id, user])

	return (
		<div>
			{t('RegisterRequestAskTitle') + ' '}
			<a
				href={'https://t.me/' + userRequest?.number}
				target="_blank"
				rel="noreferrer">
				{(
					userRequest?.firstName +
					' ' +
					userRequest?.lastName
				).trim()}
			</a>

			<Button
				type="primary"
				onClick={() => permitRegister('ALLOWED')}>
				{t('Accept')}
			</Button>
			<Button
				danger
				type="primary"
				onClick={() => permitRegister('REJECTED')}>
				{t('Reject')}
			</Button>

			<pre>{JSON.stringify(userRequest, null, 2)}</pre>
		</div>
	)
}

export default RegisterRequestAsk
